<template>
  <div class="register-content col-12 py-1 py-md-0 pb-md-1">
    <SButtonMaterial
      class="register-button"
      buttonType="button"
      textColor="white"
      size="lg"
      color="primary"
      materialClass="dense"
      text="REGISTER FOR A FREE ACCOUNT"
      to="/signup"
      data-cy="lpRegisterBtn"
    />
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
export default {
  name: "SRegisterButton",
  components: {
    SButtonMaterial,
  },
};
</script>

<style scoped>
.register-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.register-button {
  padding: 0px 8px;
  height: 3.55rem !important;
  border-radius: 1rem;
  font-size: 24px !important;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  white-space: pre-wrap;
}

@media screen and (max-width: 425px) {
  .register-button {
    height: 10rem important;
    font-size: 16px;
  }
}
</style>
